// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// GENERATED FILE: no manual modifications

import type { JsonOf } from 'lib-common/json'
import type { MealTexture } from 'lib-common/generated/api-types/specialdiet'
import type { SpecialDiet } from 'lib-common/generated/api-types/specialdiet'
import { client } from '../../api/client'
import { uri } from 'lib-common/uri'


/**
* Generated from evaka.core.specialdiet.MealTexturesController.getMealTextures
*/
export async function getMealTextures(): Promise<MealTexture[]> {
  const { data: json } = await client.request<JsonOf<MealTexture[]>>({
    url: uri`/employee/meal-textures`.toString(),
    method: 'GET'
  })
  return json
}


/**
* Generated from evaka.core.specialdiet.SpecialDietController.getDiets
*/
export async function getDiets(): Promise<SpecialDiet[]> {
  const { data: json } = await client.request<JsonOf<SpecialDiet[]>>({
    url: uri`/employee/diets`.toString(),
    method: 'GET'
  })
  return json
}
